<div class="dashboard__content mt-4 pb-5" [class.d-none]="!isLoaded">
  <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

    <div class="col-auto">
      <span class="small text-muted">Winning Hands Admin</span>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-muted text-decoration-none"> Events</a>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID]" class="small text-muted text-decoration-none">
        {{eventDetail.eventName}}</a>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID, 'bookings']"
        class="small text-primary text-decoration-none"> Bookings</a>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-auto">
      <h1 class="mb-0">BOOKINGS</h1>
    </div>
  </div>


  <div class="row">
    <div class="col-8">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Search bookings</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Hydrogen">
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Booking status</mat-label>
        <mat-select [(value)]="bookingStatus" (selectionChange)="filterTable($event.value);">
          <mat-option [value]="0">All</mat-option>
          <mat-option [value]="1">Draft</mat-option>
          <mat-option [value]="2">Booked</mat-option>
          <mat-option [value]="3">Assigned</mat-option>
          <mat-option [value]="4">Accepted</mat-option>
          <mat-option [value]="5">In progress</mat-option>
          <mat-option [value]="6">Completed</mat-option>
          <mat-option [value]="7">Cancelled</mat-option>
          <mat-option [value]="8">Declined</mat-option>
          <mat-option [value]="9">Did not happen</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>


  <div class="row">
    <div class="col-12">
      <table matSort class="admin-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="bookingId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Booking ID </th>
          <td mat-cell *matCellDef="let element">{{element.bookingId}} </td>
        </ng-container>
        <ng-container matColumnDef="bookingDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let element"> {{ element.bookingDate | date:'d MMM YYYY @ HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="waitTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Wait time </th>
          <td mat-cell *matCellDef="let element">{{element.waitTime}} </td>
        </ng-container>
        <ng-container matColumnDef="queuePos">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Queue position </th>
          <td mat-cell *matCellDef="let element">
            @if (element.queuePosition && element.queuePosition > 0){
                          {{element.queuePosition}} 
            }

          </td>
        </ng-container>
                <ng-container matColumnDef="massageLength">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Massage Length </th>
          <td mat-cell *matCellDef="let element">
          @if (element.massageLength && element.massageLength > 0){
{{element.massageLength}} mins
          }  
          </td>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element">{{element.fullName}} 
            @if (element.location && element.location.length > 0){
              <br>
              <span class="text-muted small">{{element.location}} @if (element.otherNotes && element.otherNotes.length > 0) { | {{element.otherNotes}} }</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="mobileNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile number </th>
          <td mat-cell *matCellDef="let element"> {{element.mobileNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="bookingStatusID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let element">
            {{element.bookingStatusName}}
          </td>
        </ng-container>
        <ng-container matColumnDef="requestedTherapistID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested Therapist </th>
          <td mat-cell *matCellDef="let element">
            {{element.requestedTherapistName}}

          </td>
        </ng-container>
        <ng-container matColumnDef="assignedTherapistID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Therapist </th>
          <td mat-cell *matCellDef="let element">
            {{element.assignedTherapistName}}

          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef width="10%;" mat-sort-header> Actions </th>
          <td mat-cell *matCellDef="let element">
            <button [disabled]="element.bookingStatusID === 1 || element.bookingStatusID === 2"
              matTooltip="Reset booking" (click)="resetBooking(element.bookingId)" mat-icon-button
              aria-label="Reset booking">
              <mat-icon>undo</mat-icon>
            </button>

            <button [disabled]="element.bookingStatusID === 7" matTooltip="Cancel booking"
              (click)="cancelBooking(element.bookingId)" mat-icon-button aria-label="Cancel booking">
              <mat-icon>close</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>